
export class OTPResponse {
  public ClientNotificationOTPId: number;
  public OTPCode: string;
}


